var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-calc-action-field d-flex justify-center align-center"},[_c('BaseButton',{attrs:{"disabled":_vm.isDisabled,"icon":_vm.icon,"type":"quart"},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }